import styled from "styled-components";

const SubLabel = styled.div`
  font-size: 0.75em;
  color: ${(props) => props.theme.color.dark_electric_blue};
`;

export default SubLabel;
